module.exports = __webpack_public_path__ + "static/media/jaune.80b2bcc1.png";